<div id="overlay">
    <div class="overlay-message"></div>
</div>

<app-form *ngIf="uploadOrderTemplate && flag" [configData]=uploadOrderTemplate></app-form>
<div id="schemaResult">

</div>

<app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>

<div *ngIf="!flag">
    <div fxLayout="column">
        <div>
            <span class="m-Opener-topline">Schema Validation</span>
            <h1 class="m-Opener-headline">
                Status
            </h1>
        </div>

        <div class="card">
            <div class="card-header schema-title">
                <u>Schema Validation Details</u>
            </div>
            <div class="card-body">
                <span fxFlex>Customer Name: {{formData.customerName}}</span>
                <span fxFlex> Customer Type: {{ formData.customerType}}</span>
                <span fxFlex>Template Type : {{formData.templateType}}</span>
            </div>
        </div>
        <br>
        <div *ngIf="noError" class="card">
            <div class="card-header schema-title">
                <span>
                    <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1805,24,24))">
                </span>
                <u>Schema Validation Completed</u>
            </div>
            <div class="card-body">
                <span>Status : Validation Completed</span><br>
                <span>Message : No error found</span><br>
            </div>
        </div>
        <br>
        <div *ngIf="!noError" class="card">
            <div class="card-header schema-title">
                <span>
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))" ></span>
                <u>Schema Validation Failed: </u><br>
                <span>{{msg}}</span>
            </div>
        </div>
    </div>   
</div>